/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "social-facebook-round-inline-e43e489e--sprite",
  "use": "social-facebook-round-inline-e43e489e--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"social-facebook-round-inline-e43e489e--sprite\"><g transform=\"translate(13.667 -80.833)\"><rect width=\"10.73\" height=\"17.454\" transform=\"translate(-7.131 84.14)\" fill=\"#fff\" /><path d=\"M-3.361,99.361h2.7V92.832h1.8l.238-2.25H-.663l0-1.126c0-.586.056-.9.9-.9H1.362V86.3h-1.8c-2.162,0-2.923,1.092-2.923,2.927v1.351H-4.709v2.25h1.348Zm1.694,5.472a12,12,0,0,1-12-12,12,12,0,0,1,12-12,12,12,0,0,1,12,12A12,12,0,0,1-1.667,104.833Z\" transform=\"translate(0 0)\" fill=\"#3a589b\" fill-rule=\"evenodd\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
